import { FC, useEffect, useMemo, useState } from "react"
import { useParams } from "react-router-dom";
import { Projeto } from "src/components/projetos/types";
import { STATUS_CODE } from "src/framework/providers/api";
import { ProjetosProvider } from "src/providers/ProjetosProvider";

import { notifierStore } from "src/framework/store/NotifierStore";
import { RevisaoProjeto } from "src/components/projetos/RevisaoProjeto";
import { infoScreen } from "src/store/feedbacks/Info.store";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { useHistory } from "react-router-dom";
import { ResumoRevisao } from "src/components/projetos/ResumoRevisao";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";

interface ParamsRevisao {
    codigo_projeto: string;
}

const projetosProvider = new ProjetosProvider();

const RevisaoPage: FC = () => {
    const { codigo_projeto } = useParams<ParamsRevisao>();
    const [editRow, setEditRow] = useState<Projeto | null>(null);
    // Resumo
    const [saveData, setSaveData] = useState<any>();
    const [revisaoData, setRevisaoData] = useState<any>();
    const [openResumo, setOpenResumo] = useState<boolean>(false);

    const permissoes = PermissionUtil.getPermissions();

    const standAlone = LocalStorage.get("solar.standAlone", true);

    const history = useHistory();

    const getProjeto = async (codigoProjeto: string): Promise<Projeto | null> => {
        try {

            const includes: string[] = ["disposicoes", "revisoes", "solicitacao", "distribuidor", "anexos", "revenda"]
            const response = await projetosProvider.findByKey("codigo_venda", codigoProjeto, undefined, {
                includes: includes
            });

            if (response.statusCode === STATUS_CODE.OK) {
                return response?.data?.rows || response?.data[0] || null;
            }
            notifierStore.setNotifier({
                title: "Aviso!",
                content: `Projeto com código (${codigoProjeto}) não encontrado!`,
                timeOut: 3500,
                onClose: () => {
                    notifierStore.setOpen(false);
                }
            })
            notifierStore.setOpen(true);
            return null;
        } catch (e) {

        } finally {

        }

        return null;
    }

    const init = async (): Promise<void> => {
        if (codigo_projeto) {
            const stringProjeto = Buffer.from(decodeURIComponent(codigo_projeto), "base64").toString('ascii');

            const parsedProjeto = JSON.parse(stringProjeto)

            const projeto: any = await getProjeto(parsedProjeto.codigo_projeto);

            if (projeto) {
                setEditRow({ ...projeto });
            }
        }
    }

    useEffect(() => {
        if (standAlone && !PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_VERTICAIS_MANUTENCAO, permissoes)) {
            history.push('/404', {done: true});
            return;
        }
        init()
    }, [])

    return <>
        {editRow && <RevisaoProjeto projeto={editRow}
            onExit={() => {
                history.goBack()
            }}
            onSave={(projeto, revisao) => {
                setSaveData(projeto);
                setRevisaoData(revisao);
                setOpenResumo(true);

            }}
        />}
        <ResumoRevisao
            open={openResumo}
            revisao={revisaoData}
            projeto={saveData}
            onConfirmation={(data) => {
                projetosProvider.saveRevisaoProjeto(data).then((response) => {
                    if (response.statusCode === STATUS_CODE.OK) {
                        notifierStore.setNotifier({
                            title: "Aviso!",
                            content: "Revisão salva com sucesso!",
                            timeOut: 3000,
                            onClose: () => {
                                notifierStore.setOpen(false);
                                history.replace("/projetos/menu-projetos")
                            }
                        })
                        notifierStore.setOpen(true);
                        return;
                    }

                    if (Array.isArray(response?.message)) {
                        notifierStore.setNotifier({
                            title: "Aviso!",
                            content: response.message,
                            timeOut: 3000,
                            onClose: () => {
                                notifierStore.setOpen(false);
                            }
                        })
                        notifierStore.setOpen(true);
                    }
                })

            }}
            onCancel={() => {
                setOpenResumo(false)
            }}
        />
    </>
}

export { RevisaoPage }